import {Component} from '@angular/core';
import {CommonModule} from "@angular/common";
import {AppRoutes} from "../../enums/routes";
import {AuthenticationService} from "../../_auth/authentication.service";
import {NavbarItemLargeComponent} from "../navbar-base/navbar-item-large/navbar-item-large.component";
import {NavbarContainerComponent} from "../navbar-base/navbar-container/navbar-container.component";

@Component({
  selector: 'app-navbar-user',
  templateUrl: './navbar-user.component.html',
  imports: [
    CommonModule,
    NavbarItemLargeComponent,
    NavbarContainerComponent
  ],
  styleUrls: ['./navbar-user.component.scss']
})
export class NavbarUserComponent {
  protected readonly Routes = AppRoutes;

  constructor(public AuthenticationService: AuthenticationService) {
  }
}
